// extracted by mini-css-extract-plugin
export default {"spinner-background":"LoadingSpiner_spinner-background__7cXh8","spinner":"LoadingSpiner_spinner__bleBX","spin":"LoadingSpiner_spin__QjT4+"};